import React from 'react';

import Button from '../button/Button';
import Modal from './Modal';

const BudgetSuccessModal = ({ handleClose, handleSubmit, showActions }) => {
  const focusSubmissionForm = () => {
    window.scroll(0, document.getElementById('send-budget-form').offsetTop - 250);
    handleClose();
  };

  return (
    <Modal>
      {
        showActions &&
        <div>
          <i className="c-modal__budget-icon fas fa-check" />
          <h2 className="c-modal__title">Thank You</h2>
          <p>
            Thank you for submitting your budget to help us create a balanced
            budget for the city. Share your budget with friends
            and family on social media
          </p>
          <div className="c-button-group">
            <Button onClick={handleSubmit}>
              <i className="fas fa-share-alt" /> Share
            </Button>
          </div>
        </div>
      }

      {
        !showActions &&
        <div>
          <i className="c-modal__budget-icon far fa-chart-bar" />
          <h2 className="c-modal__title">Congratulations!</h2>
          <p className="c-modal__sub-title">You have balanced the budget</p>

          <p>
            Please click submit and tell us 'why did you set this budget'.
            Or click continue balancing your budget.
          </p>

          <div className="c-button-group">
            <Button onClick={focusSubmissionForm}>Submit Your Budget</Button>
            <Button onClick={handleClose}>Review Your Budget</Button>
          </div>
        </div>
      }
    </Modal>
  )
};

export default BudgetSuccessModal;



// WEBPACK FOOTER //
// ./src/components/common/modal/BudgetSuccessModal.jsx